<template>
    <div>
        <div v-if="$router.currentRoute.name === 'MaintenanceFinish'">
            <slot name="MaintenanceFinish"></slot>
        </div>
        <div class="steps" v-else>
            <slot name="MaintenanceVehicle">
                <div class="step _completed">
                    <div class="step-name _vehicle">
                        {{ $t('stepNames.carAndDealer') }}
                    </div>
                    <button class="step-edit" @click="backToStep('MaintenanceVehicle')">
                        <span class="step-edit__text">{{ $t('stepNames.edit') }}</span>
                    </button>
                    <div class="step-info">
                        <ul class="step-info__list">
                            <li class="step-info__item">
                                <span class="step-info__name">{{ $t('common.model') }}</span>
                                <span class="step-info__value">{{ modelInfo.model.name }}</span>
                            </li>
                            <li class="step-info__item">
                                <span class="step-info__name">{{ $t('maintenance.airType') }}</span>
                                <span class="step-info__value">{{ modelInfo.air.name }}</span>
                            </li>
                            <li class="step-info__item">
                                <span class="step-info__name">{{ $t('maintenance.engineSize') }}</span>
                                <span class="step-info__value">{{ modelInfo.engine.name }}</span>
                            </li>
                            <li class="step-info__item">
                                <span class="step-info__name">{{ $t('maintenance.fuel') }}</span>
                                <span class="step-info__value">{{ modelInfo.fuel.name }}</span>
                            </li>
                            <li class="step-info__item">
                                <span class="step-info__name">{{ $t('maintenance.modelYear') }}</span>
                                <span class="step-info__value">{{ modelInfo.year.name }}</span>
                            </li>
                            <li class="step-info__item" :class="{'_dealer-completed':  !($route.name === 'MaintenanceDealer')}">
                                <span class="step-info__name">{{ $t('maintenance.city') }}</span>
                                <span class="step-info__value">{{ cityInfo }}</span>
                            </li>
                        </ul>

                        <div class="step-info__block" v-if="!($route.name === 'MaintenanceDealer')">
                            <div class="step-info__name">
                                {{ dealerInfo.name }}
                            </div>
                            <div class="step-info__value _address">
                                {{ dealerInfo.address }}
                            </div>
                        </div>
                    </div>
                </div>
            </slot>

            <slot name="MaintenanceDealer"></slot>

            <!--<slot name="MaintenanceServices">
                <div class="step"
                     :class="[showStepDetails('MaintenanceServices') ? '_completed' : '_disabled']">
                    <div class="step-name _services">
                        {{ $t('stepNames.services') }}
                    </div>
                    <div class="step-info">

                        <div class="total step-info__name">
                            <span class="total__value">{{ totalCost }}</span>
                        </div>

                        <ul class="services__list">
                            <li class="services__item" v-for="service in servicesInfo">
                                <span class="step-info__value">{{service.description}}</span>
                            </li>
                            <li class="services__item" v-for="reviewCampaign in reviewCampaignsInfo">
                                <span class="step-info__value">{{reviewCampaign.description}}</span>
                            </li>
                        </ul>
                    </div>
                    <button class="step-edit" @click="backToStep('MaintenanceServices')">
                        <span class="step-edit__text">{{ $t('stepNames.edit') }}</span>
                    </button>
                </div>
            </slot>-->

            <slot name="MaintenanceTime">
                <div class="step"
                     :class="[showStepDetails('MaintenanceTime') ? '_completed' : '_disabled']">
                    <div class="step-name _time">
                        {{ $t('stepNames.dateAndTime') }}
                    </div>
                    <div class="step-info">
                        <div class="step-info__name">
                            {{ dateTimeInfo.title }}
                        </div>
                    </div>
                    <button class="step-edit" @click="$router.push({name: 'MaintenanceTime'})">
                        <span class="step-edit__text">{{ $t('stepNames.edit') }}</span>
                    </button>
                </div>
            </slot>

            <slot name="MaintenanceContacts">
                <div class="step"
                     :class="[showStepDetails('MaintenanceContacts') ? '_completed' : '_disabled']">
                    <div class="step-name _contacts">
                        {{ $t('stepNames.contacts') }}
                    </div>
                    <div class="step-info">
                        <ul class="step-info__list _few-item">
                            <li class="step-info__item">
                                <span class="step-info__name">{{ $t('common.firstName') }}</span>
                                <span class="step-info__value">{{ clientInfo.firstName }} {{ clientInfo.middleName }} {{ clientInfo.lastName }}</span>
                            </li>
                            <li class="step-info__item _phone">
                                <span class="step-info__name">{{ $t('common.telephone') }}</span>
                                <span class="step-info__value">{{ clientInfo.phone }}</span>
                            </li>
                            <li class="step-info__item _email">
                                <span class="step-info__name">{{ $t('common.email') }}</span>
                                <span class="step-info__value ">{{ clientInfo.email }}</span>
                            </li>
                        </ul>
                    </div>
                    <button class="step-edit" @click="$router.push({name: 'MaintenanceContacts'})">
                        <span class="step-edit__text">{{ $t('stepNames.edit') }}</span>
                    </button>
                </div>
            </slot>

            <slot name="MaintenanceConfirmation">
                <div class="step _disabled">
                    <div class="step-name _confirmation">
                        {{ $t('stepNames.confirmation') }}
                    </div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        name: 'MaintenanceSteps',


        computed: {
            cityInfo() {
                const city = this.$store.state.userLocation.description;
                if (city) {
                    return city.split(',', 1).join();
                } else {
                    return '';
                }
            },

            modelInfo() {
                return {
                    model: this.$store.state.maintenanceSelected.vehicleInfo.model,
                    air: this.$store.state.maintenanceSelected.vehicleInfo.air,
                    fuel: this.$store.state.maintenanceSelected.vehicleInfo.fuel,
                    engine: this.$store.state.maintenanceSelected.vehicleInfo.engine,
                    year: this.$store.state.maintenanceSelected.vehicleInfo.year,
                }
            },

            dealerInfo() {
                return this.$store.state.maintenanceSelected.dealer;
            },

            servicesInfo() {
                return this.$store.getters.maintenanceFormattedServices;
            },

            reviewCampaignsInfo() {
                return this.$store.state.maintenanceSelected.reviewCampaigns;
            },

            totalCost() {
                return this.$store.getters.maintenanceTotalCost;
            },

            dateTimeInfo() {
                return this.$store.getters.maintenanceFormattedTime;
            },

            clientInfo() {
                return this.$store.state.maintenanceSelected.clientInfo
            }
        },


        watch: {
            '$route': 'scrollToStepBeginning'
        },


        methods: {
            ...mapMutations([
                'clearMaintenanceDealer',
                'clearMaintenanceServices',
                'clearMaintenanceDateTime'
            ]),

            scrollToStepBeginning() {
                if(this.$route.name !== 'MaintenanceFinish') {
                    const interval = setInterval(() => {
                        const routeRootElement = this.$slots[this.$route.name][0].elm;
                        if (routeRootElement) {
                            this.$scrollTo(routeRootElement);
                            clearInterval(interval);
                        }
                    }, 100);
                }
            },

            backToStep(name) {
                switch (name) {
                    case 'MaintenanceVehicle': {
                        this.clearMaintenanceDealer();
                        this.clearMaintenanceServices();
                    }
                    case 'MaintenanceServices':
                        this.clearMaintenanceDateTime();
                }
                this.$router.push({name: name});
            },

            showStepDetails(name) {
                let result;
                switch(name) {
                    case 'MaintenanceServices':
                        result = this.dealerInfo.name &&
                            (
                                this.$route.name === 'MaintenanceTime' ||
                                this.$route.name === 'MaintenanceContacts' ||
                                this.$route.name === 'MaintenanceConfirmation'
                            );
                        break;
                    case 'MaintenanceTime':
                        result = this.dateTimeInfo.title &&
                            (
                                this.$route.name === 'MaintenanceContacts' ||
                                this.$route.name === 'MaintenanceConfirmation'
                            );
                        break;
                    case 'MaintenanceContacts':
                        result = this.clientInfo.phone && this.$route.name === 'MaintenanceConfirmation';
                        break;
                }
                return result;
            }
        }
    }
</script>

<style lang="less" scoped>

    @import (less) '../../styles/_media.less';
    @import (less) '../../styles/colors.less';
    @import (less) '../../styles/paddings.less';

    .dot() {
        content: '';
        background: @jaguarClarified;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin: 0 5px;
    }


    .services {
        &__list {
            text-align: left;
            padding: 0;
            margin: 0;
            list-style: none;
        }

        &__item {
            display: inline-block;

            .land-rover-style & {
                &::before {
                    width: 4px;
                    height: 4px;
                    .dot;
                }
            }

            .jaguar-style & {
                @media screen and (max-width: @sm-max) {
                    &::before {
                        width: 2px;
                        height: 2px;
                        .dot;
                    }
                }

                @media @desktop {
                    &:first-child::before {
                        width: 2px;
                        height: 2px;
                        .dot;
                    }

                    &:not(:last-child)::after {
                        content: ",";
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
            }

            .step-info__value {
                display: inline !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/MaintenanceSteps.vue